<template>
    <div class="main">
        <div class="wp4">
            <div class="page-tit dffs">
                <router-link class="back-btn" to="/userCenter/industryGuest/guestBookingList"></router-link>
                产业嘉宾活动列表
            </div>

            <div class="act-list">
                <div v-for="item in list" :key="item.id" class="item" @click="onView(item.content)">
                    <div class="inner">
                        <div class="pic">
                            <img :src="srcComputed(item.coverImageId)" alt="">
                        </div>
                        <div class="text">
                            <div class="type">{{ item.activityTypeName }}</div>
                            <div class="tit">
                                <span>{{ item.activityName }}</span>
                            </div>
                            <div class="info">
                                <p>活动时间：{{ item.activityStartTime | timeFilter('{y}年{m}月{d}日') }}</p>
                                <p v-if="item.activityAdress">活动地点：{{ item.activityAdress }}</p>
                                <p v-if="item.isSignFlag == 1">
                                    报名时间：{{ item.signStartTime | timeFilter('{y}.{m}.{d}') }} ~ {{ item.signEndTime |
                                        timeFilter('{y}.{m}.{d}') }}
                                </p>
                            </div>
                            <div class="status" :class="{ 'status-booked': item.subscribeFlag }">
                                <span
                                    :class="{ 'needs-appointment': item.isSignFlag == 1, 'no-appointment': item.isSignFlag != 1 }">
                                    {{ item.isSignFlag == 1 ? '需要预约' : '无需预约' }}
                                </span>
                                <a v-if="item.isSignFlag == 1" class="btn"
                                    :class="{ 'booked': item.subscribeFlag, 'transparent-btn': item.isSignFlag != 1 }"
                                    :disabled="item.subscribeFlag" @click.stop="appointBtn(item)">
                                    {{ item.subscribeFlag ? '已预约' : '预约' }}
                                </a>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
import { sessionData } from "@/static/js/local.js";
import { activityApi } from '@/api/industry';
let that;

export default {
    data() {
        return {
            userInfo: {},
            list: []
        }
    },
    computed: {
        srcComputed() {
            return function (id) {
                let imgSrc = '';
                if (id && id !== '') {
                    imgSrc = process.env.VUE_APP_IMG_BASE_URL + id;
                }
                return imgSrc
            }
        }
    },
    filters: {
        timeFilter: function (tsp, type) {
            try {
                if (!tsp || tsp.toString().length == 0) {
                    return ''
                }

                return that.$parseTime(tsp, type)
            } catch (err) {
                return ''
            }
        },
    },
    beforeCreate() {
        that = this;
    },
    created() {
        this.userInfo = sessionData("get", "UserInfo");
        if (this.userInfo && this.userInfo.accountId) {
            this.getList();
        } else {
            this.$message.warning('请先登录');
            this.goBack();
        }
    },
    methods: {
        getList() {
            const loading = this.$Loading.service({
                text: "",
                customClass: "custom-loading",
            });
            activityApi.getActivityList({
                page: {
                    pageNum: 1,
                    pageSize: 99999,
                    total: 0
                },
                mainId: this.$session.get("cmm").mainId,
                accountId: this.userInfo.accountId
            }).then(res => {
                if (res.data && res.data.count > 0) {
                    this.list = res.data.result;
                    console.log(this.list);

                }
            }).finally(() => {
                setTimeout(() => {
                    loading.close();
                }, 500);
            })
        },
        goBack() {
            this.$router.push("/myActivity");
        },
        appointBtn(obj) {
            if (obj.activityLink) {
                location.href = obj.activityLink;
                return;
            }
            this.$msgbox({
                title: "确认信息",
                message: `确认预约“${obj.activityName}”`,
                showClose: false,
                showCancelButton: true,
                cancelButtonClass: "cancel-btn-color",
                confirmButtonClass: "btn-color",
                callback: (action, instance) => {
                    if (action == "confirm") {
                        activityApi.sign({
                            guestActivityId: obj.id,
                            accountId: this.userInfo.accountId,
                            mainId: this.$session.get("cmm").mainId
                        }).then(res => {
                            this.$message.success('预约成功');
                            this.getList();
                        })
                    }
                }
            });
        },
        onView(content) {
            if (!content) {
                // this.$message.info('该活动暂无详情内容');
                return
            }
            this.$msgbox({
                title: '详情',
                message: content,
                dangerouslyUseHTMLString: true,
                showConfirmButton: false,
                customClass: 'detail-msgbox'
            })
        }
    }
}
</script>
<style scoped>
.pic {
    img {
        height: 100%;
    }
}

.btn {
    cursor: pointer;
}

/* 已预约状态 */
.status-booked {
    border: 1px solid #cccccc !important;
    /* 边框颜色 */
}

.booked {
    background-color: #cccccc !important;
    /* 按钮颜色 */
    cursor: not-allowed;
    pointer-events: none;
}

/* 无需预约状态下的透明按钮 */
.transparent-btn {
    background-color: transparent !important;
    border: none;
    color: #999999;
    cursor: not-allowed;
    pointer-events: none;
}
</style>